import { ShardMigrationStatus } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllShardMigrationStatuses = () =>
  getAllEnumOptions(ShardMigrationStatus)

export const getShardMigrationStatusLabel = (key?: ShardMigrationStatus) => {
  if (key === null || typeof key === 'undefined') return ''

  return ShardMigrationStatus[key]
}
